// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Up_AH","right":"styles_right__1QJ7T"};